import React, { useState } from 'react';
import { Window, WindowActionsBar, WindowActionsEvent } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { useNavigate, useParams } from 'react-router-dom';
import { SvgIcon } from '@progress/kendo-react-common';
import { UserApi } from '../../../../../../redux/api/UserApi';
import { isMobile } from 'react-device-detect';
import * as svg from '@progress/kendo-svg-icons';
import EditAssignment from './EditAssignment';
import { TicketApi } from '../../../../../../redux/api/TicketApi';
import { PartialSpinny } from '../../../../../Nav/Spinny';
import './Reassign.scss';
import { max } from 'lodash';

const AssignedModal: React.FC = () => {
    const navigate = useNavigate();
    const { ticketId } = useParams();
    const [selectedUser, setSelectedUser] = useState();
    const [stage, setStage] = useState(isMobile ? 'FULLSCREEN' : 'DEFAULT');
    const { data: userProfile } = UserApi.useGetUserProfileQuery();
    const [newAssignees, setNewAssignees] = useState<number[]>([]);
    const [setAssigned, { isLoading: savingChanges }] = TicketApi.useReassignMutation();

    //navigate back when the winow is closed
    const onStageChange = (e: WindowActionsEvent) => {
        //setVisible(false);
        setStage(e.state)
    }

    const handleSave = (e) => {
        if (newAssignees?.length) {
            setAssigned({ TicketId: parseInt(ticketId), New_Assignees: newAssignees }).unwrap().then(() => {
                //Go back   
                navigate('/ticket/' + ticketId);
            });
        } else {
            goBack();
        }
    };


    const goBack = () => {
        navigate('/ticket/' + ticketId);
    }

    return (<>
        <Window modal={true} className='cool-window reassign-window' minimizeButton={() => null} title={<><SvgIcon size='large' icon={svg.userOutlineIcon} className='mr-2' ></SvgIcon>Edit Ownership</>} onClose={() => navigate(-1)}
            initialHeight={650} initialWidth={1000}
            stage={stage} onStageChange={onStageChange}>
            <div>
                {savingChanges && <PartialSpinny />}
                {/* newAssignees: {newAssignees?.length} */}
                <EditAssignment ticketId={parseInt(ticketId)} onChange={(e) => setNewAssignees(e)} />
            </div>
            <style>
                {`body, html{
                max-height: 100vh;
                overflow: hidden;
            }`}
            </style>
            <WindowActionsBar>
                <Button disabled={!newAssignees?.length} onClick={handleSave} svgIcon={svg.saveIcon} type='submit' className='justify-content-end p-2' style={{ marginTop: '20px', color: '#fff', backgroundColor: userProfile?.Nav_Hex_Color }}>
                    Save Ownership
                </Button>
                <Button fillMode='outline' svgIcon={svg.cancelIcon} className='justify-content-end p-2' style={{ marginTop: '20px' }} onClick={goBack}>
                    Cancel
                </Button>
            </WindowActionsBar>
        </Window>

    </>
    );
};

export default AssignedModal;